// extracted by mini-css-extract-plugin
export default {"button":"rectangle_button_button__Cl+HA"};